import React, { Fragment, useState } from 'react';
import classNames from 'classnames';
import { FCP } from 'types';

import { generateRandomKey } from 'utils';

import styles from './expandableSection.module.css';

interface ExpandableSectionProps extends FCP {
  sectionHeader: string | React.ReactNode;
  sectionBody?: string | React.ReactNode;
  initialState?: boolean;
  expandIcon?: React.ReactNode;
  animateBody?: boolean;
}

const ExpandableSection = (props: ExpandableSectionProps) => {
  const {
    sectionHeader = '',
    sectionBody = '',
    children,
    initialState = true,
    expandIcon,
    animateBody = false
  } = props;

  const [expand, setExpand] = useState(initialState);

  const toggleSection = () => {
    setExpand((prev) => !prev);
  };

  const getIcon = (expandState: boolean, customIcon: React.ReactNode) => {
    return customIcon ? (
      <i
        className={classNames(
          'ml-auto',
          styles[expandState ? 'customIconOpen' : 'customIconClosed']
        )}
      >
        {customIcon}
      </i>
    ) : (
      <i className={classNames('ml-auto', expandState ? 'icon-angle-up' : 'icon-angle-down')} />
    );
  };

  return (
    <section id={generateRandomKey()} className={classNames('w-100', 'z-ml-0')}>
      <div
        className={classNames(
          'd-flex align-items-start cursor-pointer',
          styles['contextTitlesHead']
        )}
        onClick={toggleSection}
        onKeyDown={(e) => [' ', 'Enter'].includes(e.key) && toggleSection()}
        tabIndex={0}
      >
        <Fragment>{sectionHeader}</Fragment>

        {getIcon(expand, expandIcon)}
      </div>

      {expand && (
        <div className={classNames({ [styles.animateBody]: animateBody })}>
          {sectionBody || children}
        </div>
      )}
    </section>
  );
};

export default ExpandableSection;
